import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import translate from '@/lib/intl/translate';

type EditButtonProps = IconButtonProps & {
  iconClassName?: string;
  label?: string;
  showTooltip?: boolean;
};

function EditButton({
  iconClassName = '',
  label = translate('EDIT'),
  showTooltip = true,
  ...props
}: EditButtonProps) {
  const btn = (
    <IconButton
      color="primary"
      aria-label={label}
      size="small"
      edge="start"
      {...props}
    >
      <EditIcon className={iconClassName} />
    </IconButton>
  );

  if (showTooltip && label) {
    return <Tooltip title={label}>{btn}</Tooltip>;
  }

  return btn;
}

export default EditButton;
